export const selectCashBoxes = state => state.cashBoxes.cashBoxes
export const selectAssignedCashBoxes = state => state.cashBoxes.assignedCashBoxes
export const selectCashBox = state => state.cashBoxes.cashBox
